__turbopack_context__.v({
  "divider": "CartSection-module__R2AqIa__divider",
  "dividerGapLg": "CartSection-module__R2AqIa__dividerGapLg",
  "dividerGapMd": "CartSection-module__R2AqIa__dividerGapMd",
  "dividerGapNone": "CartSection-module__R2AqIa__dividerGapNone",
  "dividerGapSm": "CartSection-module__R2AqIa__dividerGapSm",
  "dividerGapXl": "CartSection-module__R2AqIa__dividerGapXl",
});
